<template>
  <div class="sevenchart-area">
    <!-- <div class="seven-chart">
      <div class="itemname">項目A</div>
      <div class="chartsclae">
        <div v-for="n of 7" :class="setClassName(n,n)" :key="`bar1-${n}`">{{n}}</div>
      </div>
      <div class="itemname -right">項目B</div>
    </div>-->

    <div v-for="(item,num) in items" class="seven-chart" :key="num">
      <div class="itemname">{{item.name}}</div>
      <div class="chartsclae">
        <div v-for="n of 7" :class="setClassName(n,item.val)" :key="n"></div>
      </div>
      <div class="itemname -right">{{item.name2}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["sevenData"],
  data() {
    return {
      items: [
        { num: 1, name: "内向的", name2: "外向的", val: this.sevenData[0] },
        { num: 2, name: "自信家", name2: "心配性", val: this.sevenData[1] },
        { num: 3, name: "自由", name2: "規律", val: this.sevenData[2] },
        { num: 4, name: "挑戦的", name2: "友好的", val: this.sevenData[3] },
        { num: 5, name: "経験重視", name2: "理論重視", val: this.sevenData[4] },
        { num: 6, name: "大胆", name2: "慎重", val: this.sevenData[5] },
        {
          num: 7,
          name: "ゼネラリスト",
          name2: "スペシャリスト",
          val: this.sevenData[6],
        },
      ],
    };
  },
  computed: {
    setClassName() {
      return function (num, val) {
        let fill = "";
        if (num == val) {
          fill = " -fill" + num;
        }
        return "sc" + fill;
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.seven-chart {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  > .itemname {
    flex: 0 0 100px;
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
    &.-right {
      text-align: left;
      padding-right: 0;
      padding-left: 10px;
    }
  }
  > .chartsclae {
    flex: 1 1 auto;
    display: flex;
    height: 20px;
    border-left: 1px solid #000;
  }
  .sc {
    flex: 0 0 14.2857142%;
    height: 100%;
    border: 1px solid #000;
    border-left: none;
    box-sizing: border-box;
    background-color: #ddd;
    display: flex;
    justify-content: center;
    align-items: center;

    &.-fill1,
    &.-fill7 {
      background-color: #0a9;
      background-color: #1788dd;
    }
    &.-fill2,
    &.-fill6 {
      background-color: #0ba;
      background-color: lighten(#1788dd,5%);
    }
    &.-fill3,
    &.-fill5 {
      background-color: #0cb;
      background-color: lighten(#1788dd,10%);
    }
    &.-fill4 {
      background-color: #0dc;
      background-color: lighten(#1788dd,15%);
    }
  }
}
</style>